export default __webpack_public_path__ + "static/media/frame_dark_grey.bb7b5e2b.png";